import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import Header from 'components/Header'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  heading,
  title,
  lead,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  return (
    <div className={globalClasses.join(' ')}>
      <Header heading={heading} title={title} lead={lead} colorMode={colorMode} tenant={tenant.key}/>
    </div>
  )
}

export default MainComponent
